import { render, staticRenderFns } from "./WavesAerialito.vue?vue&type=template&id=59804938&scoped=true&"
import script from "./WavesAerialito.vue?vue&type=script&lang=ts&"
export * from "./WavesAerialito.vue?vue&type=script&lang=ts&"
import style0 from "./WavesAerialito.vue?vue&type=style&index=0&id=59804938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59804938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59804938')) {
      api.createRecord('59804938', component.options)
    } else {
      api.reload('59804938', component.options)
    }
    module.hot.accept("./WavesAerialito.vue?vue&type=template&id=59804938&scoped=true&", function () {
      api.rerender('59804938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Animations/WavesAerialito.vue"
export default component.exports